import { createAsyncThunk } from '@reduxjs/toolkit';

import { authAPI } from '@/modules/auth/api';
import { authClientV3 } from '@/modules/auth/api/v3';
import { AUTH_MODES, getAuthMode } from '@/modules/auth/mode';
import { partnerAPI } from '@/modules/partner/api';
import { IPartner } from '@/modules/partner/model';
import { namespace } from '@/modules/partner/namespace';
import { getUserData } from '@/modules/user/store/selectors';
import { RootState } from '@/root-store';

const createPartner = createAsyncThunk(
  `${namespace}/create-partner`,
  async (
    _,
    { getState },
  ): Promise<{
    partner?: IPartner;
    errors?: {
      partner_exists?: string[];
    };
  }> => {
    const me = getUserData(getState() as RootState);

    const { partner, errors } = await partnerAPI.createPartner(me);

    if (errors) {
      return { errors };
    }

    if (partner) {
      // The partner role reaches the token only on a refresh, and which stack
      // owns the session decides whose token that is: an email-first visitor has
      // no legacy session at all, so refreshing the legacy one would leave every
      // later onboarding call carrying claims from before the role existed.
      //
      // Neither refusal undoes a partner upstream has already created, so a
      // failure here is swallowed: the transport refreshes again on its first
      // 401 regardless.
      if (getAuthMode() === AUTH_MODES.LEGACY) {
        await authAPI.refreshToken().catch(() => undefined);
      } else {
        await authClientV3.refreshSession();
      }

      return { partner };
    }

    return {};
  },
);

export { createPartner };
